import Vue from 'vue';
import initInterceptor from '../layoutid_RWJOB/common/interceptor';
import jobDetails from './applications/job-details.vue';
import similarsSlider from './applications/similars-slider.vue';
import tabSlider from '../layoutid_RWJOB/common/tab-slider';
import youtubeEmbed from '../layoutid_RWJOB/applications/youtube-embed.vue';
import pageLoader from '../layoutid_RWJOB/applications/page-loader.vue';

initInterceptor();

/* eslint-disable no-new */
new Vue({
	el: '#rwjobv-app',
	components: {
		jobDetails,
		similarsSlider,
		tabSlider,
		youtubeEmbed,
		pageLoader
	}
});
